import React from "react";

import { FiltersData, FiltersQuery } from "../../../../queries/filters/components/FiltersQuery";
import { NotFoundError } from "../../../../utils/error";
import { FiltersContext } from "./context";
import { IEntityFilter } from "./types";

const isValidFilterData = (data?: FiltersData): boolean =>
  Boolean(data) && Boolean(data!.entityFilterList);

export const FiltersContextProvider: React.FC = ({ children }) => (
  <FiltersQuery>
    {({ loading, error, data }) => {
      if (error) {
        throw error;
      }
      if (!loading && !isValidFilterData(data)) {
        throw new NotFoundError();
      }
      return (
        <FiltersContext.Provider
          value={{
            entityFilters: data!.entityFilterList as IEntityFilter[],
            loading
          }}
        >
          {children}
        </FiltersContext.Provider>
      );
    }}
  </FiltersQuery>
);
